export default function getResource(label, vars = []) {
    const resources = {
        productPrice: 'Prix',
        fillSize: 'Taille de remplissage',
        rating: 'Cote',
        ingredientHighlights: 'Avantages des ingrédients',
        seeDetails: 'Voir tous les détails',
        value: 'valeur',
        goodFor: 'Idéal pour',
        targetedConcerns: 'Cible les préoccupations suivantes',
        skinValues: `${vars[0]} Peau`,
        hairValues: `${vars[0]} Cheveux`,
        highlyRated: 'Évalué très favorablement par les clients pour'
    };

    return resources[label];
}
